<template>
  <div class="row form-group">
    <div class="col-12">
      <p><b>UWAGA!</b></p>

      <p><b>Na podstawie art. 8 ust. 3-13 ustawy z dnia 12 marca 2004 r. o pomocy społecznej:</b></p>

      <ol>
        <li>
          Za dochód zgodnie z ust. 3 ww. ustawy uważa się sumę miesięcznych przychodów z miesiąca poprzedzającego
          złożenie wniosku lub w przypadku utraty dochodu z miesiąca, w którym wniosek został złożony, bez względu na
          tytuł i źródło ich uzyskania pomniejszoną o:
          <ul>
            <li>miesięczne obciążenie podatkiem dochodowym od osób fizycznych;</li>

            <li>składki na ubezpieczenie zdrowotne oraz ubezpieczenia społeczne;</li>

            <li>kwotę alimentów świadczonych na rzecz innych osób.</li>
          </ul>
        </li>

        <li>
          Do dochodu ustalonego zgodnie z ust. 3 ww. ustawy nie wlicza się:
          <ul>
            <li>jednorazowego pieniężnego świadczenia socjalnego;</li>

            <li>zasiłku celowego;</li>

            <li>
              pomocy materialnej mającej charakter socjalny albo motywacyjny, przyznawanej na podstawie przepisów o
              systemie oświaty;
            </li>

            <li>wartości świadczenia w naturze;</li>

            <li>
              świadczenia przysługującego osobie bezrobotnej na podstawie przepisów o promocji zatrudnienia i
              instytucjach rynku pracy z tytułu wykonywania prac społecznie użytecznych;
            </li>

            <li>
              świadczenia pieniężnego i pomocy pieniężnej, o których mowa w ustawie z dnia 20 marca 2015 r. o
              działaczach opozycji antykomunistycznej oraz osobach represjonowanych z powodów politycznych (Dz.U z 2018
              r. poz. 690 );
            </li>

            <li>dochodu z powierzchni użytków rolnych poniżej 1 ha przeliczeniowego;</li>

            <li>
              świadczenia wychowawczego, o którym mowa w ustawie z dnia 11 lutego 2016 r. o pomocy państwa w
              wychowywaniu dzieci (Dz. U. z 2018 r. poz. 2134), oraz dodatku wychowawczego, o którym mowa w ustawie z
              dnia 9 czerwca 2011 r. o wspieraniu rodziny i systemie pieczy zastępczej (Dz.U. z 2019 r. poz. 1111);
            </li>

            <li>
              świadczenia pieniężnego, o którym mowa w art. 8a ust. 1 ustawy z dnia 7 września 2007 r. o Karcie Polaka
              (Dz.U. z 2019 poz. 1598).
            </li>

            <li>
              świadczenia pieniężnego przyznawanego na podstawie art.9 ustawy z dnia 22 listopada 2018 r. o grobach
              weteranów walk o wolność i niepodległość Polski (Dz. U. Poz. 2529);
            </li>

            <li>
              nagrody specjalnej Prezesa Rady Ministrów przyznawanej na podstawie art. 31 a ustawy z dnia 8 sierpnia
              1996 r. o Radzie Ministrów (Dz. U. z 2019 r. Poz. 1171).
            </li>
          </ul>
        </li>

        <li>
          W stosunku do osób prowadzących pozarolniczą działalność gospodarczą:
          <small>(W sytuacji gdy podatnik łączy przychody z działalności gospodarczej z innymi przychodami lub rozlicza się
            wspólnie z małżonkiem, przez podatek należny, o którym mowa w ust. 5 pkt 1 ww. ustawy o pomocy społecznej,
            rozumie się podatek wyliczony w takiej proporcji, w jakiej pozostaje dochód podatnika z</small>

          <ul>
            <li>
              opodatkowaną podatkiem dochodowym od osób fizycznych na zasadach określonych w przepisach o podatku
              dochodowym od osób fizycznych - za dochód przyjmuje się przychód z tej działalności pomniejszony o koszty
              uzyskania przychodu, obciążenie podatkiem należnym określonym w przepisach o podatku dochodowym od osób
              fizycznych i składkami na ubezpieczenie zdrowotne określonymi w przepisach o świadczeniach opieki
              zdrowotnej finansowanych ze środków publicznych, związane z prowadzeniem tej działalności oraz odliczonymi
              od dochodu składkami na ubezpieczenia społeczne niezaliczonymi do kosztów uzyskania przychodów,
              określonymi w odrębnych przepisach, z tym że dochód ustala się, dzieląc kwotę dochodu z działalności
              gospodarczej wykazanego w zeznaniu podatkowym złożonym za poprzedni rok kalendarzowy przez liczbę
              miesięcy, w których podatnik prowadził działalność, a jeżeli nie prowadził działalności, za dochód
              przyjmuje się kwotę zadeklarowaną w oświadczeniu tej osoby;
            </li>

            <li>
              opodatkowaną na zasadach określonych w przepisach o zryczałtowanym podatku dochodowym od niektórych
              przychodów osiąganych przez osoby fizyczne - za dochód przyjmuje się kwotę zadeklarowaną w oświadczeniu
              tej osoby.
            </li>
          </ul>
        </li>

        <li>Przyjmuje się, że z 1 ha przeliczeniowego uzyskuje się dochód miesięczny w wysokości 308 zł).</li>

        <li>
          Dochody z pozarolniczej działalności gospodarczej i z ha przeliczeniowych oraz z innych źródeł sumuje się.
        </li>

        <li>
          W przypadku uzyskania w ciągu 12 miesięcy poprzedzających miesiąc złożenia wniosku lub w okresie pobierania
          świadczenia z pomocy społecznej dochodu jednorazowego przekraczającego pięciokrotnie kwoty kryterium
          dochodowego rodziny, w przypadku osoby w rodzinie tj. 528 zł)
          <ul>
            <li>
              kwotę tego dochodu rozlicza się w równych częściach na 12 kolejnych miesięcy, poczynając od miesiąca, w
              którym dochód został wypłacony.
            </li>
          </ul>
        </li>

        <li>
          W przypadku uzyskania jednorazowo dochodu należnego za dany okres, kwotę tego dochodu uwzględnia się w
          dochodzie osoby lub rodziny przez okres, za który uzyskano ten dochód.
        </li>

        <li>
          W przypadku uzyskiwania dochodu w walucie obcej, wysokość tego dochodu ustala się według średniego kursu
          Narodowego Banku Polskiego z dnia wydania decyzji administracyjnej w sprawie świadczenia z pomocy społecznej.
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
// @vuese
// Income statement component
// @Group formComponents
export default {};
</script>
